<script setup>
import { computed } from 'vue'
import { useGamesNotificationStore } from '../stores/gamesNotificationStore'

const gamesNotificationStore = useGamesNotificationStore()

const hasNewGames = computed(() => gamesNotificationStore.hasNewGames)
const unreadCount = computed(() => gamesNotificationStore.unreadCount)
const hasGames = computed(() => gamesNotificationStore.games.length > 0)
const showHeader = computed(() => hasGames.value || gamesNotificationStore.showOverlay)

const handleClick = () => {
  if (gamesNotificationStore.showOverlay) {
    gamesNotificationStore.closeOverlay()
  } else {
    gamesNotificationStore.openOverlay()
  }
}
</script>

<template>
  <transition
    enter-active-class="transition-all duration-300 ease-out"
    leave-active-class="transition-all duration-300 ease-in"
    enter-from-class="opacity-0 -translate-y-full"
    enter-to-class="opacity-100 translate-y-0"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 -translate-y-full"
  >
    <div
      v-if="showHeader"
      class="fixed top-0 left-1/2 -translate-x-1/2 w-[300px] z-50 bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-lg rounded-b-lg"
    >
      <button
        @click="handleClick"
        class="w-full px-6 py-3 flex items-center justify-between hover:bg-pink-600 transition-colors"
      >
        <div class="flex items-center gap-3">
          <div class="relative">
            <i class="fas fa-basketball-ball text-xl"></i>
            <div
              v-if="unreadCount > 0"
              class="absolute -top-1 -right-1 w-5 h-5 bg-yellow-400 text-gray-900 rounded-full text-xs font-bold flex items-center justify-center animate-pulse"
            >
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </div>
          </div>
          <div class="text-left">
            <div class="font-semibold text-sm">
              New Games Available
            </div>
            <div class="text-xs opacity-90">
              <span v-if="unreadCount > 0">{{ unreadCount }} new game{{ unreadCount !== 1 ? 's' : '' }}</span>
              <span v-else>{{ gamesNotificationStore.games.length }} total game{{ gamesNotificationStore.games.length !== 1 ? 's' : '' }}</span>
              <span class="ml-1">- Click to {{ gamesNotificationStore.showOverlay ? 'close' : 'view' }}</span>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <i :class="['fas', gamesNotificationStore.showOverlay ? 'fa-chevron-up' : 'fa-chevron-down', 'text-sm']"></i>
        </div>
      </button>
    </div>
  </transition>
</template>

<style scoped>
</style>
